var map = {
	"./after_party.png": 1826,
	"./after_party@2x.png": 1827,
	"./brunch.png": 1828,
	"./brunch@2x.png": 1829,
	"./camera.svg": 1830,
	"./ceremony.png": 1831,
	"./ceremony@2x.png": 1832,
	"./check.svg": 714,
	"./checklist-white-bg.svg": 1833,
	"./checklist.svg": 1834,
	"./chevron-white-thick-left.png": 1835,
	"./chevron-white-thick-right.png": 1836,
	"./chevron-white-thick.png": 1837,
	"./confetti.svg": 1838,
	"./dashboard.svg": 1839,
	"./desktop_events.svg": 1840,
	"./download.svg": 1841,
	"./dropdown-focus.svg": 1802,
	"./dropdown.svg": 1801,
	"./envelope.svg": 1842,
	"./envelope_gray.svg": 1843,
	"./events.svg": 1844,
	"./faq-checklist.png": 1845,
	"./faq-checklist.svg": 1846,
	"./faq-guestlist.png": 1847,
	"./faq-guestlist.svg": 1848,
	"./faq-registry.png": 1849,
	"./faq-registry.svg": 1850,
	"./faq-website.png": 1851,
	"./faq-website.svg": 1852,
	"./guest_list-white-bg.svg": 1853,
	"./guest_list.svg": 1854,
	"./guestlist-white-bg-trimmed.svg": 1855,
	"./help.svg": 1856,
	"./icon-chrome.png": 1857,
	"./icon-chrome.svg": 506,
	"./icon-invites.png": 1858,
	"./icon-invites.svg": 1859,
	"./icon-website.svg": 1860,
	"./iconX.svg": 485,
	"./icon_empty.svg": 942,
	"./illustrative_website.svg": 1522,
	"./menu.svg": 1861,
	"./np_hidden.png": 1862,
	"./other.png": 1863,
	"./other@2x.png": 1864,
	"./profile-photo.png": 1311,
	"./profile-photo@2x.png": 1865,
	"./reception.png": 1866,
	"./reception@2x.png": 1867,
	"./redPresent.svg": 1868,
	"./registry-white-bg.svg": 1869,
	"./registry.svg": 1870,
	"./rehearsal_dinner.png": 1871,
	"./rehearsal_dinner@2x.png": 1872,
	"./remove.svg": 521,
	"./silhouette.png": 1873,
	"./speech-bubble.svg": 866,
	"./trashbin.png": 1874,
	"./trashcan.svg": 1875,
	"./website-white-bg.svg": 1876,
	"./website.svg": 1877,
	"./wedding.png": 1878,
	"./wedding@2x.png": 1879,
	"./welcome_event.png": 1880,
	"./welcome_event@2x.png": 1881,
	"./x-circle-dark.svg": 1882,
	"./x-circle-light.svg": 1883
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 941;


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons nonrecursive \.(jpg|jpeg|png|gif|svg)(\?.*)?$
// module id = 941
// module chunks = 71